import ExcelJS from "exceljs";
import {
  bloodGroupArray,
  covidVaccineArray,
  durationOfContractArray,
  flattenObjectInObjects,
  flattenObjectsInArray,
  probationPeriodArray,
  religionArray,
} from "../candidateListFunctions";

const statusArray = [
  "MEDICALLY UNFIT",
  "BACKED OUT",
  "UNDER PROCESS FOR VISA STAMP",
  "SELECTED",
  "VISA STAMPED",
  "VISA CANCELLED",
  "REQUIREMENT FULFILLED",
  "TRAVELLING",
];

const headings = [
  {
    key: "point_of_hire",
    title: "POINT OF HIRE",
    type: "text",
    defaultValue: "OVERSEAS",
  },
  // {
  //   key: "visa_cost/transfer_cost",
  //   title: "VISA COST/TRANSFER COST",
  //   type: "text",
  // },
  {
    key: "quotation_quotation_type_name",
    title: "QUOTATION TYPE",
    type: "text",
    path: "project",
  },
  {
    key: "quotation_hour_type",
    title: "HOUR TYPE",
    type: "text",
    path: "project",
  },
  { key: "name", title: "PROJECT NAME", type: "text", path: "project" },
  {
    key: "quotation_quotation_number",
    title: "QUOTATION NUMBER",
    type: "text",
    path: "project",
  },
  {
    key: "contract_contract_number",
    title: "CONTRACT NUMBER",
    type: "text",
    path: "project",
  },
  { key: "client_name", title: "CLIENT NAME", type: "text", path: "project" },
  {
    key: "company_name",
    title: "VISA PROVIDER",
    type: "text",
    path: "project",
  },
  // {
  //   key: "rec_agency_name",
  //   title: "REC. AGENCY NAME",
  //   type: "text",
  // },
  // { key: "selection_sector", title: "SELECTION SECTOR", type: "text" },
  { key: "nationality_name", title: "NATIONALITY", type: "text" },
  {
    key: "religion",
    title: "RELIGION",
    type: "dropdown",
    dropdownArray: religionArray,
  },
  { key: "selection_date", title: "DATE OF SELECTION", type: "date" },
  { key: "approval_remark", title: "APPROVAL REMARK", type: "text" },
  { key: "name", title: "NAME", type: "text" },
  { key: "passport_number", title: "PASSPORT NO", type: "text" },
  { key: "job_position_name", title: "ACTUAL PROFESSION", type: "text" },
  { key: "dob", title: "DATE OF BIRTH", type: "text" },
  { key: "age", title: "AGE", type: "text" },
  { key: "selection_grade", title: "SELECTION GRADE", type: "text" },
  { key: "basic", title: "Basic", type: "number" },
  { key: "food", title: "Food", type: "number" },
  { key: "fixed_ot", title: "Fixed OT", type: "number" },
  { key: "hra", title: "HRA", type: "number" },
  { key: "travel_allowance", title: "Travel Allowance", type: "number" },
  { key: "mobile_allowance", title: "Mobile Allowance", type: "number" },
  {
    key: "air_ticket_allowance",
    title: "Air Ticket Allowance",
    type: "number",
  },
  { key: "additional_ot", title: "Additional OT", type: "number" },
  { key: "other_allowance", title: "Other Allowance", type: "number" },
  { key: "duty_hours", title: "Duty Hours", type: "number" },
  { key: "fixed_ot_hours", title: "Fixed OT Hours", type: "number" },
  // { key: "service_charge", title: "SERVICE CHARGE", type: "number" },
  {
    key: "duration_of_contract",
    title: "DURATION OF CONTRACT",
    type: "dropdown",
    dropdownArray: durationOfContractArray,
  },
  {
    key: "probation_period",
    title: "PROBATION PERIOD",
    type: "dropdown",
    dropdownArray: probationPeriodArray,
  },
  { key: "passport_issue_date", title: "PASSPORT ISSUE DATE", type: "date" },
  { key: "passport_expiry_date", title: "PASSPORT EXPIRY DATE", type: "date" },
  {
    key: "emergency_contact_person_in_home_country",
    title: "EMERGENCY CONTACT PERSON IN HOME COUNTRY",
    type: "text",
  },
  {
    key: "emergency_contact_number_in_home_country",
    title: "EMERGENCY CONTACT NUMBER IN HOME COUNTRY",
    type: "text",
  },
  {
    key: "covid_vaccine",
    title: "COVID VACCINE",
    type: "dropdown",
    dropdownArray: covidVaccineArray,
  },
  {
    key: "blood_group",
    title: "BLOOD GROUP",
    type: "dropdown",
    dropdownArray: bloodGroupArray,
  },
  { key: "candidate_id", title: "EMPLOYEE ID", type: "text" },
  { key: "visa_block_number", title: "VISA BLOCK NUMBER", type: "text" },
  { key: "sponsor_id", title: "SPONSOR ID", type: "text" },
  { key: "visa_profession_name", title: "VISA PROFESSION", type: "text" },
  {
    key: "visa_reference_number",
    title: "VISA REFERENCE NUMBER",
    type: "text",
  },
  { key: "visa_stamping_date", title: "VISA STAMPING DATE", type: "text" },
  {
    key: "candidate_flight_flight_details",
    title: "FLIGHT DETAILS",
    type: "text",
  },
  { key: "candidate_flight_country", title: "COUNTRY", type: "text" },
  {
    key: "candidate_flight_date_of_departure",
    title: "DATE OF DEPARTURE",
    type: "text",
  },
  {
    key: "candidate_flight_time_of_departure",
    title: "TIME OF DEPARTURE",
    type: "text",
  },
  {
    key: "candidate_flight_date_of_arrival",
    title: "DATE OF ARRIVAL",
    type: "text",
  },
  {
    key: "candidate_flight_time_of_arrival",
    title: "TIME OF ARRIVAL",
    type: "text",
  },
  {
    key: "candidate_flight_sector_name",
    title: "ARRIVAL SECTOR",
    type: "text",
  },
  {
    key: "candidate_flight_pickup_to_be_arranged",
    title: "PICKUP TO BE ARRANGED",
    type: "dropdown",
    dropdownArray: [],
  },
  {
    key: "candidate_flight_project_incharge",
    title: "PROJECT INCHARGE",
    type: "text",
  },
  {
    key: "status",
    title: "CANDIDATE STATUS",
    type: "dropdown",
    dropdownArray: statusArray,
  },
];

export default function flightDetails(filteredCandidates = [], projectDetails) {
  console.log(projectDetails, "projectDetails in excel");
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  const titleRow = sheet.getRow(1);
  titleRow.getCell(1).value = "SNO.";
  for (let i = 0; i <= headings.length; i++) {
    titleRow.getCell(i + 1).style = {
      alignment: { horizontal: "center", vertical: "middle" },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFF00" }, // Yellow color in ARGB format
      },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } }, // Black color
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    if (headings[i] == "job_position_name") {
      titleRow.getCell(i + 2).value = "ACTUAL PROFESSION";
    } else {
      titleRow.getCell(i + 2).value = headings[i]?.title;
    }

    const column = sheet.getColumn(i + 2);
    column.width = 24;
  }

  // Set header height
  sheet.getRow(1).height = 30;
  const projectFlattenArray = flattenObjectInObjects(projectDetails);
  console.log(projectFlattenArray, "project flatten array");

  for (let i = 0; i < filteredCandidates?.length; i++) {
    const row = sheet.getRow(i + 2);
    row.getCell(1).value = i + 1;
    for (let j = 0; j < headings.length; j++) {
      if (headings[j].path == "project") {
        row.getCell(j + 2).value = projectFlattenArray[headings[j].key] || "-";
      } else {
        if (headings[j].type == "dropdown") {
          row.getCell(j + 2).value =
            filteredCandidates[i][headings[j].key] || "-";
          const dropdownArray = [`"${headings[j].dropdownArray.toString()}"`];
          row.getCell(j + 2).dataValidation = {
            type: "list",
            formulae: dropdownArray,
            allowBlank: true,
            operator: "equal",
            promptTitle: "Select an option",
          };
        } else if (headings[j].type == "number") {
          row.getCell(j + 2).value =
            filteredCandidates[i][headings[j].key] || "-";

          row.getCell(j + 2).dataValidation = {
            type: "whole",
            operator: "greaterThanOrEqual",
            showErrorMessage: true,
            formulae: [0],
            errorStyle: "error",
            error: "The value must be a number",
          };
        } else {
          row.getCell(j + 2).value =
            filteredCandidates[i][headings[j].key] ||
            headings[j].defaultValue ||
            "-";
        }
      }
    }
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Flight Details.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    +URL.revokeObjectURL(url);
  });
}
